// extracted by mini-css-extract-plugin
export var box = "_34-0";
export var check = "_34-1";
export var checkboxButton = "_34-6";
export var checkboxGroup = "_34-5";
export var disabled = "_34-7";
export var ghost = "_34-9";
export var input = "_34-2";
export var label = "_34-4";
export var normal = "_34-8";
export var uncheck = "_34-3";